import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, reactive, ref } from "vue"
import { TranslateResult } from "vue-i18n"

import InfiniteScrollSelect from "@/components/Common/InfiniteScrollSelect/index.vue"
import i18n from "@/i18n"
import { fetchAttributeUnits } from "@/modules/offers/api/productModeration"
import {
  ProductModerationAttribute,
  ProductModerationAttributeUnit
} from "@/modules/offers/types/offers"

import { getAttributeLabel, getAttributeValueLabel } from "../../utils/attributeLabels"
import { hasAttributeValue } from "../../utils/productAttributes"

type Props = {
  attribute: ProductModerationAttribute
  showDeleteButton?: boolean
  showValidation?: boolean
  disabled?: boolean
}
type Emits = {
  (event: "remove", attribute: ProductModerationAttribute): void
  (event: "change", attribute: ProductModerationAttribute): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeInputRow',
  props: {
    attribute: null,
    showDeleteButton: { type: Boolean },
    showValidation: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["remove", "change"],
  setup(__props: any, { emit }: { emit: ({
  (event: "remove", attribute: ProductModerationAttribute): void
  (event: "change", attribute: ProductModerationAttribute): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  attribute: ProductModerationAttribute
  showDeleteButton?: boolean
  showValidation?: boolean
  disabled?: boolean
};




const form = reactive({
  value: undefined,
  unit: undefined
})

const validateStatus = computed<string>(() => {
  if (!props.attribute.is_required) return "success"

  if (!props.showValidation) return "success"

  return hasAttributeValue(props.attribute) ? "success" : "error"
})
const fieldValidationMessage = computed<TranslateResult>(() =>
  validateStatus.value === "error" ? i18n.t("validations.required_field") : ""
)

const removeAttribute = () => {
  emit("remove", props.attribute)
}
const onValueChanged = () => {
  emit("change", {
    ...props.attribute,
    value: [
      {
        value: form.value,
        unit: form.unit
          ? defaultUnitOptions.value.find((item) => item.oid === form.unit) || { oid: form.unit }
          : undefined
      }
    ]
  })
}

// UNITS
const defaultUnitOptions = ref([])

const onUnitChange = (value: string) => {
  form.unit = value
  onValueChanged()
}
const setUnit = (unit: ProductModerationAttributeUnit) => {
  if (unit) {
    defaultUnitOptions.value.push(unit)
    form.unit = unit.oid
  }
}
const setupAttribute = () => {
  const [currentValue] = props.attribute?.value || []

  if (currentValue) {
    setUnit(currentValue.unit || props.attribute.default_unit)

    form.value = getAttributeValueLabel(currentValue)
  } else if (props.attribute.default_unit) {
    setUnit(props.attribute.default_unit)
  }
}

onMounted(setupAttribute)

return { __sfc: true,props, emit, form, validateStatus, fieldValidationMessage, removeAttribute, onValueChanged, defaultUnitOptions, onUnitChange, setUnit, setupAttribute, InfiniteScrollSelect, fetchAttributeUnits, getAttributeLabel }
}

})